import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Clock3,
  User,
  Calendar,
  ArrowLeft,
  ArrowRight,
  Tag,
} from "lucide-react";
import blogs from "./blogData";

function BlogDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const blog = blogs.find((item) => item.slug === slug);

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold">Blog Not Found</h2>
          <button
            onClick={() => navigate("/blogs")}
            className="mt-5 px-5 py-3 bg-[#4B2D83] text-white rounded-xl"
          >
            Back to Blogs
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#faf8fd] min-h-screen">

      {/* Hero */}
      <section className="bg-gradient-to-r from-[#4B2D83] to-[#6B46C1] py-10">
        <div className="max-w-5xl mx-auto px-5 pt-0">

          <button
            onClick={() => navigate("/blogs")}
            className="flex items-center gap-2 text-white/90 hover:text-white"
          >
            <ArrowLeft size={18} />
            Back to Blogs
          </button>

          <span className="inline-flex px-4 py-2 rounded-full bg-white/20 text-white text-sm">
            {blog.category}
          </span>

          <h1 className="text-xl md:text-xl font-bold text-white mt-5 leading-tight">
            {blog.title}
          </h1>

          <p className="text-white/60 mt-6 text-md ">
            {blog.summary}
          </p>

          <div className="flex flex-wrap gap-6 mt-4 text-white/90">

            <div className="flex items-center gap-2">
              <User size={18} />
              {blog.authorName}
            </div>

            <div className="flex items-center gap-2">
              <Clock3 size={18} />
              {blog.readingTime} min read
            </div>

            <div className="flex items-center gap-2">
              <Calendar size={18} />
              {new Date(blog.publishedAt).toLocaleDateString()}
            </div>

          </div>
        </div>
      </section>

      {/* Article */}
    <section className="max-w-6xl mx-auto px-5 py-12">

  <div className="grid lg:grid-cols-[350px_1fr] gap-10">

    {/* Left Side Sticky Image */}
    <div className="hidden lg:block">
      <div className="sticky top-8">

        <img
          src={blog.featuredImage}
          alt={blog.title}
          className="
          w-full
          h-96
          object-cover
          "
        />

        {/* Tags */}
        {blog.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-6">
            {blog.tags.map((tag) => (
              <span
                key={tag}
                className="
                  bg-purple-100
                  text-[#4B2D83]
                  px-3 py-1
                  rounded-full
                  text-xs
                  font-medium
                "
              >
                {tag}
              </span>
            ))}
          </div>
        )}

      </div>
    </div>

    {/* Mobile Image */}
    <div className="lg:hidden">
      <img
        src={blog.featuredImage}
        alt={blog.title}
        className="
          w-full
          rounded-3xl
          shadow-xl
          object-cover
        "
      />
    </div>

    {/* Right Side Content */}
    <div>

      <article className="bg-white rounded-3xl shadow-md p-6 md:p-10">

        {blog.content?.map((section, index) => (
          <div
            key={index}
            className="mb-12 last:mb-0"
          >
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5">
              {section.heading}
            </h2>

            <p className="text-gray-700 text-base md:text-lg whitespace-pre-line">
              {section.content}
            </p>
           {section.bulletPoints && (
  <div className="mt-5 space-y-3 text-left ml-8">
    {section.bulletPoints
      .split("\n")
      .filter(Boolean)
      .map((item, i) => {
        const text = item.trim();

        const isHeading =
          text.endsWith(":") ||
          text.includes("Benefits") ||
          text.includes("Analysis") ||
          text.includes("Tracking") ||
          text.includes("Learning Environment") ||
          text.includes("Rankings");

        return isHeading ? (
          <h4
            key={i}
            className="font-semibold text-lg text-gray-900 mt-4"
          >
            {text}
          </h4>
        ) : (
          <li
            key={i}
            className=" list-disc text-gray-700"
          >
            {text}
          </li>
        );
      })}
  </div>
)}
          </div>
        ))}

      </article>

      {/* CTA */}
      {/* <div className="mt-10 bg-[#4B2D83] rounded-3xl p-8 md:p-12">

        <h2 className="text-3xl font-bold text-white">
          Ready to Start Your Learning With Earning Journey?
        </h2>

        <p className="text-purple-100 mt-4">
          Learn smarter, practice consistently, compete confidently
          and unlock reward opportunities through Adhyayi.
        </p>

        <button
          className="
            mt-8
            inline-flex
            items-center
            gap-2
            bg-white
            text-[#4B2D83]
            px-8
            py-4
            rounded-xl
            font-semibold
            hover:scale-105
            transition-all
          "
        >
          Get Started
          <ArrowRight size={18} />
        </button>

      </div> */}

    </div>

  </div>

</section>
    </div>
  );
}

export default BlogDetails;